<template>
  <div>
    <div
      class="p-1 d-flex align-items-center"
      @click="toggleFolder(folder.folderID)"
      :style="
        selectedFolder && selectedFolder.folderID === folder.folderID
          ? 'background:#E1EEF7'
          : ''
      "
    >
      <div @click.stop="" class="common-single-checkbox">
        <b-form-checkbox
          name="checkbox-1"
          :value="folder.folderID"
          @change="folderSelected(folder.folderID)"
          v-model="selectedFoldersIDs"
        ></b-form-checkbox>
      </div>
      <div :style="{ 'margin-left': `${depth}px` }">
        <template v-if="folder.childFolders.length">
          <img
            v-show="!expandStatus.has(folder.folderID)"
            src="../../../assets/img/newcreatejob/closearrow.svg"
            alt=""
          />
          <img
            v-show="expandStatus.has(folder.folderID)"
            src="../../../assets/img/newcreatejob/openarrow.svg"
            alt=""
          />
        </template>
        <span
          class="createjobs-teams-checkbox-label"
          :class="folder.childFolders.length ? 'ml-2' : 'ml-0'"
          >{{ folder.folderName }}</span
        >
      </div>
    </div>
    <div
      v-for="folders in folder.childFolders"
      :key="folders.folderID"
      class="mt-2"
    >
      <!-- :style="{ 'margin-left': `${depth + 5}px` }" -->
      <AllocateFolderCard
        v-if="expandStatus.has(folder.folderID)"
        :folder="folders"
        :depth="depth + 10"
        :level="level + 1"
        :expandStatus="expandStatus"
        :selectedFolder="selectedFolder"
        :folderSelectionState="folderSelectionState"
        :totalSelectedFolderIDs="totalSelectedFolderIDs"
        :removeList="removeList"
        @toggle-folder="toggleFolder"
        @folder-checked="folderSelectEmit"
        @folderId-saved="folderIdSaved"
        @remove-content="removeContent"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "AllocateFolderCard",
  props: {
    expandStatus: Set,
    folder: Object,
    selectedFolder: Object,
    totalSelectedFolderIDs: Array,
    removeList: Array,
    depth: Number,
    level: Number,
    folderSelectionState: String,
  },
  data() {
    return {
      selectedFoldersIDs: [],
    };
  },
  created() {
    if (this.totalSelectedFolderIDs.includes(this.folder.folderID)) {
      this.selectedFoldersIDs.push(this.folder.folderID);
    }
  },
  watch: {
    folderSelectionState() {
      if (this.folderSelectionState === "add") {
        if (!this.selectedFoldersIDs.includes(this.selectedFolder.folderID)) {
          this.selectedFoldersIDs.push(this.selectedFolder.folderID);
        }
      } else if (this.folderSelectionState === "remove") {
        for (const index in this.selectedFoldersIDs) {
          if (this.selectedFoldersIDs[index] === this.selectedFolder.folderID) {
            this.selectedFoldersIDs.splice(index, 1);

            break;
          }
        }
      } else if (this.folderSelectionState === "updateArray") {
        for (const folderID of this.totalSelectedFolderIDs) {
          if (
            this.folder.folderID === folderID &&
            !this.selectedFoldersIDs.includes(folderID)
          ) {
            this.selectedFoldersIDs.push(folderID);
            break;
          }
        }
      } else if (this.folderSelectionState === "removeArray") {
        if (this.removeList.includes(this.folder.folderID)) {
          const index = this.selectedFoldersIDs.indexOf(this.folder.folderID);
          if (index !== -1) {
            this.selectedFoldersIDs.splice(index, 1);
          }
        }
      }
      this.$emit("folderId-saved");
    },
  },
  methods: {
    folderSelectEmit(folderID) {
      this.$emit("folder-checked", folderID);
    },
    toggleFolder(folderID) {
      this.$emit("toggle-folder", folderID);
    },
    folderIdSaved() {
      this.$emit("folderId-saved");
    },
    removeContent(folderID) {
      this.$emit("remove-content", folderID);
    },
    folderSelected(folderID) {
      if (!this.totalSelectedFolderIDs.includes(folderID)) {
        this.$emit("folder-checked", folderID);
      } else {
        this.$emit("remove-content", folderID);
      }
    },
  },
};
</script>
